// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"cebfe587","787":"2ba962ef"}[chunkId] + ".chunk.js";
};